import React from 'react'
import type { IconProps } from '../types'
import { getIconSize } from '../types'

/**
 * IconCircleCheckGreen - Solid green circle with white check mark
 * Matches legacy green-circle-check asset (16x16 default)
 */
export const IconCircleCheckGreen: React.FC<IconProps> = ({ className, style, color, fill, ...props }) => {
  const { width, height } = getIconSize({ size: 16, ...props })
  const circleFill = fill ?? color ?? '#22C55E'
  return (
    <svg
      className={className}
      // eslint-disable-next-line no-restricted-syntax
      style={style}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="8" cy="8" r="8" fill={circleFill} />
      <path d="M4 8.5L6.5 11L12 5.5" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default IconCircleCheckGreen

